import React from "react";
import { ChevronDown, Paperclip } from "lucide-react";
import OutlineButton from "./OutlineButton";

const OutlineButtonExample: React.FC = () => (
	<div className="space-y-8 p-6">
		<div>
			<h3 className="mb-4 text-lg font-semibold">OutlineButton Example</h3>

			<div className="flex flex-wrap items-center gap-3">
				<OutlineButton label="Välj kontaktperson" icon={<ChevronDown size={15} />} />
				<OutlineButton label="Ladda upp dokument (1)" icon={<Paperclip size={14} />} />
				<OutlineButton label="Utan ikon" />
				<OutlineButton label="Inaktiverad" icon={<ChevronDown size={15} />} disabled />
			</div>
		</div>
	</div>
);

export default OutlineButtonExample;
